export default __webpack_public_path__ + "static/media/lightTheme.3c3b225a.png";